import { ErrorHandler, inject, Injectable } from "@angular/core";
import { environment, EventBusService, LogService, UserService } from "@mypxplat/xplat/core";
import { BugsnagErrorHandler } from "@bugsnag/plugin-angular";
import Bugsnag from "@bugsnag/js";
import { Router } from "@angular/router";

@Injectable()
export class WebErrorHandler extends ErrorHandler {
  log: LogService;
  router: Router;
  eventBusService: EventBusService;
  userService: UserService;
  bugSnag: BugsnagErrorHandler;

  constructor() {
    super();
    this.log = inject(LogService);
    this.router = inject(Router);
    this.eventBusService = inject(EventBusService);
    this.userService = inject(UserService);
    this.bugSnag = new BugsnagErrorHandler();
  }

  handleError(error: any) {
    // Get the current route and origin
    const currentUrl = this.router.url;
    const currentOrigin = window.location.origin;
    // Check if we should skip Bugsnag reporting
    const isCheckoutRoute = !environment.features.bugsnag_on_checkout && currentUrl.startsWith("/checkout");
    const isAdminApp = environment.adminUrl && currentOrigin.startsWith(environment.adminUrl.replace(/\/$/, ""));

    if (isCheckoutRoute || isAdminApp) {
      // Optionally log the error locally, but don't report to Bugsnag
      this.log.debug(isAdminApp ? "Error in admin app. Not reporting to Bugsnag." : "Error on /checkout route. Not reporting to Bugsnag.");
      console.log(error);
    } else {
      // Proceed with normal error handling (including Bugsnag)
      this.log.debug("error", error);

      if (error && error.status && (error.status == 403 || error.status == 401)) {
        if (error.url && error.url.indexOf("paeapi") > -1) {
          this.userService.tokenExpired$.next(true);
        }
      } else if (error?.error?.error) {
        const errorMsg = error.error.error;
        if (errorMsg == "Your access token is invalid or has expired.") {
          this.userService.tokenExpired$.next(true);
        }
      } else if (error?.message && error.message.indexOf("ChunkLoadError") > -1) {
        this.eventBusService.emit(this.eventBusService.types.showNewCodeAlert, true);
      } else {
        // report the error to Bugsnag
        this.log.info("Submitting to Bugsnag.");
        this.bugSnag.handleError(error); // <-- Call the original BugsnagErrorHandler's handleError
      }
    }
  }

  reportError(error) {
    Bugsnag.notify(error);
  }
}
